var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import "promise-polyfill/src/polyfill";
import { loadPolyfills } from "./loadPolyfills";
import { subscribe, publish, publishToModules, unsubscribe, intercept, clearIntercept } from "./messageBus";
import { getModuleParameter, loadModules } from "./loadModules";
import { loadGame, prepareGameFrame, prepareGameUrl } from "./loadGame";
import { createResizeListener } from "./createResizeListener";
import { fetchLayerConfig } from "./fetchLayerConfig";
import { loadTranslations, translate } from "./translate";
import { getGameRefParameter, getParameter, validateParameters } from "./getParameter";
import { createMessageEventListener } from "./messageEventListener";
import { formatCurrency } from "./formatCurrency";
import { prepareGameOrigin } from "./postMessageOrigin";
import { fetchLauncherConfig } from "./fetchLauncherConfig";
import { fetchNexusConfig } from "./fetchNexusConfig";
import { loadFeatures } from "./loadFeatures";
import { getCombinedDependencies } from "./getCombinedDependencies";
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    yield loadPolyfills();
    if (!CSS.supports("height: 100dvh")) {
        createResizeListener();
    }
    const pathConfig = yield fetchNexusConfig();
    yield validateParameters(pathConfig);
    const responses = yield Promise.all([
        fetchLauncherConfig(pathConfig),
        fetchLayerConfig(pathConfig)
    ]);
    const gameConfig = {};
    subscribe("configure", (newConfig) => {
        Object.assign(gameConfig, newConfig);
    });
    const environment = {
        launcherConfig: responses[0],
        baseConfig: pathConfig,
        getGameRefParameter,
        gameConfig
    };
    const config = responses[1];
    createMessageEventListener();
    const dependencies = yield getCombinedDependencies(config);
    const features = yield loadFeatures(dependencies, config);
    window.nexus = {
        subscribe,
        publish,
        publishToModules,
        translate,
        unsubscribe,
        getParameter,
        configuration: config,
        formatCurrency,
        getModuleParameter,
        environment,
        features,
        intercept,
        clearIntercept
    };
    prepareGameFrame(config);
    prepareGameUrl();
    prepareGameOrigin();
    yield loadTranslations(config, dependencies, getParameter("lang")).catch((reason) => {
        console.error(reason.message);
    });
    const gameLoadPriority = 0;
    yield loadModules(config, [Number.MIN_SAFE_INTEGER, gameLoadPriority - 1], dependencies);
    loadModules(config, [gameLoadPriority, gameLoadPriority], dependencies).catch((error) => {
        console.warn(error);
    });
    yield loadGame(pathConfig);
    loadModules(config, [gameLoadPriority + 1, Number.MAX_SAFE_INTEGER], dependencies).catch((error) => {
        console.warn(error);
    });
});
init().then(() => {
}).catch((reason) => {
    console.log(`APEX INIT FAILED: ${reason}`);
});
